<template>
  <div class="ordersEditScreen">
    <ProductModal
      v-if="showModal && selectedProductID.indexOf('PRE_') === -1"
      :productID="selectedProductID"
      :editData="selectedProductData"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showModal = false"
    ></ProductModal>

    <PredefinedProductModal
      v-if="showModal && selectedProductID.indexOf('PRE_') >= 0"
      :productID="selectedProductID"
      :editData="selectedProductData"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showModal = false"
    ></PredefinedProductModal>

    <FreeTextProductModal
      :editData="selectedProductData"
      v-if="showFreeArticleModal"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showFreeArticleModal = false"
    ></FreeTextProductModal>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>
            {{
              isStockWorkshopOrder
                ? id === 'new'
                  ? 'Nuevo pedido (stock)'
                  : `Pedido ${id} (stock)`
                : `Pedido ${id}`
            }}
          </h3>

          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row v-if="!isStockWorkshopOrder">
              <b-col cols="12">
                <h4>Datos cliente</h4>
              </b-col>
              <b-form-group
                id="input-customer"
                label="Cliente"
                label-for="customer"
                class="col-4"
              >
                <b-form-row>
                  <multiselect
                    :multiple="false"
                    track-by="value"
                    @input="customersMultiselectChanged"
                    placeholder=""
                    :options="customersMultiselect.loadedOptions"
                    :loading="customersMultiselect.isLoading"
                    label="text"
                    v-model="$v.form.customer.$model"
                  >
                  </multiselect>

                  <small
                    v-if="$v.form.customer.$error"
                    id="input-customer-feedback"
                    class="invalid-customer text-danger"
                  >
                    Este campo es obligatorio.
                  </small>

                  <small
                    v-if="
                      billing_address_full &&
                      form.customer === null &&
                      is_web_sale
                    "
                    style="color: red"
                    >Venta web hecha como invitado (sin registro). Consultar
                    campo "Dirección de envío".</small
                  >
                </b-form-row>
              </b-form-group>

              <b-form-group
                id="input-shippingMethod"
                class="col-4"
                label="Método de envío"
                label-for="shippingMethod"
              >
                <b-form-select
                  :options="shippingMethodSelect.loadedOptions"
                  id="shippingMethod"
                  @change="shippingMethodChanged"
                  v-model="$v.form.shippingMethod.$model"
                  :state="validateState('shippingMethod')"
                  aria-describedby="input-shippingMethod-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-shippingMethod-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-shippingAddress"
                class="col-4"
                label="Dirección de envío"
                label-for="shippingAddress"
              >
                <b-form-select
                  :options="shippingAddressSelect.loadedOptions"
                  :disabled="
                    ![3, 4, 5, 6, 7].includes($v.form.shippingMethod.$model)
                  "
                  id="shippingAddress"
                  v-model="$v.form.shippingAddress.$model"
                  :state="validateState('shippingAddress')"
                  aria-describedby="input-shippingAddress-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-shippingAddress-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >

                <b-card
                  v-if="
                    billing_address_full &&
                    form.customer === null &&
                    is_web_sale
                  "
                >
                  <span
                    :key="i"
                    v-for="(v, i) in $options.filters.formatBillingAddress(
                      this.billing_address_full
                    )"
                  >
                    {{ v }}<br />
                  </span>
                </b-card>
              </b-form-group>

              <b-form-group
                id="input-created_by"
                class="col-3"
                label="Creado por"
                label-for="created_by"
              >
                <multiselect
                  :multiple="true"
                  track-by="value"
                  placeholder=""
                  :options="employeeProfileMultiSelect.loadedOptions"
                  :loading="employeeProfileMultiSelect.isLoading"
                  label="text"
                  v-model="$v.form.created_by.$model"
                >
                </multiselect>

                <!-- <b-form-select
                  :options="employeeProfileMultiSelect.loadedOptions"
                  id="created_by"
                  v-model="$v.form.created_by.$model"
                  :state="validateState('created_by')"
                  aria-describedby="input-created_by-feedback"
                ></b-form-select> -->

                <b-form-invalid-feedback id="input-created_by-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-billingAddress"
                class="col-4"
                label="Dirección de facturación"
                label-for="billingAddress"
              >
                <b-form-select
                  :options="billingAddressSelect.loadedOptions"
                  id="billingAddress"
                  @change="billingAddressSelectChanged"
                  v-model="$v.form.billingAddress.$model"
                  :state="validateState('billingAddress')"
                  aria-describedby="input-billingAddress-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-billingAddress-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >

                <b-card
                  class="mt-2"
                  v-if="this.billingAddressSelect.selectedAddress"
                >
                  <span
                    :key="i"
                    v-for="(v, i) in $options.filters.formatBillingAddress(
                      this.billingAddressSelect.selectedAddress
                    )"
                  >
                    {{ v }}<br />
                  </span>
                </b-card>
              </b-form-group>

              <b-form-group
                id="input-saleType"
                class="col-2"
                label="Tipo de venta"
                label-for="saleType"
              >
                <b-form-select
                  :options="saleTypeSelect.options"
                  id="saleType"
                  v-model="$v.form.saleType.$model"
                  @change="saleTypeChanged"
                  aria-describedby="input-saleType"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                id="input-incotermType"
                class="col-2"
                label="Incoterm"
                label-for="incotermType"
              >
                <b-form-select
                  :disabled="incotermTypeSelect.disabled"
                  :options="incotermTypeSelect.options"
                  id="incotermType"
                  :state="validateState('incotermType')"
                  v-model="$v.form.incotermType.$model"
                  @change="incotermTypeChanged"
                  aria-describedby="input-incotermType-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-incotermType-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>
            <b-form-row v-if="!isStockWorkshopOrder">
              <b-form-group
                id="input-discountType"
                class="col-2"
                label="Tipo de descuento"
                label-for="discountType"
              >
                <b-form-select
                  :disabled="id !== 'new'"
                  :options="discountTypeSelect.options"
                  id="discountType"
                  v-model="$v.form.discountType.$model"
                  @change="discountTypeChanged"
                  aria-describedby="input-discountType"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                class="col-4"
                id="input-extra_concept"
                label="Concepto aclaratorio"
                label-for="extra_concept"
                description="Añade una línea personalizable en la factura, antes de la tabla de artículos."
              >
                <b-form-input
                  id="extra_concept"
                  v-model="$v.form.extra_concept.$model"
                  :state="validateState('extra_concept')"
                  aria-describedby="input-extra_concept-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-extra_concept-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                class="col-6"
                id="input-one_liner_grouping_concept"
                label="Concepto agrupación en factura"
                label-for="one_liner_grouping_concept"
                description="Concepto bajo el cual se agruparán todos los productos al generar la factura; si se deja este campo en blanco en blanco, la factura seguirá el formato habitual."
              >
                <b-form-input
                  id="one_liner_grouping_concept"
                  v-model="$v.form.one_liner_grouping_concept.$model"
                  :state="validateState('one_liner_grouping_concept')"
                  aria-describedby="input-one_liner_grouping_concept-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-one_liner_grouping_concept-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row class="mt-2">
              <b-col cols="12">
                <h4>Estado del pedido</h4>

                <b-form-row>
                  <b-col cols="12">
                    <b-form-radio-group
                      @change="changedStatus"
                      id="radio-group-1"
                      v-model="selectedStatus"
                      name="radio-options"
                    >
                      <b-row no-gutters>
                        <b-col
                          class="orderStatusBox"
                          :class="{ active: selectedStatus === elem.status }"
                          v-for="(elem, i) in orderStatusHistoriesFmt"
                          :key="i"
                        >
                          <b-row>
                            <b-col cols="auto">
                              <div>
                                <h6>{{ elem.status | formatStatus }}</h6>
                                <span>{{ elem.date ? elem.date : '-' }}</span>
                              </div>
                            </b-col>
                            <b-col align-self="center" class="text-right">
                              <b-form-radio
                                :disabled="disableStatusRadioBtn(i)"
                                :value="elem.status"
                              >
                              </b-form-radio>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-form-row class="mt-4 pb-3">
              <b-col cols="12">
                <h4>Artículos</h4>
              </b-col>

              <b-col :cols="6">
                <multiselect
                  :disabled="id !== 'new'"
                  track-by="value"
                  @search-change="asyncFindProducts"
                  placeholder=""
                  :options="productsMultiselect.loadedOptions"
                  :loading="productsMultiselect.isLoading"
                  :internal-search="false"
                  :options-limit="50"
                  label="text"
                  v-model="form.product"
                >
                </multiselect
              ></b-col>

              <b-col cols="2">
                <b-button
                  variant="outline-primary"
                  block
                  :disabled="id !== 'new'"
                  @click="addArticleToQuoteBtn"
                  >Añadir artículo</b-button
                >
              </b-col>

              <b-col cols="2">
                <b-button
                  variant="outline-primary"
                  block
                  :disabled="id !== 'new'"
                  @click="addFreeTextArticleToQuoteBtn"
                  >Añadir línea libre</b-button
                >
              </b-col>
            </b-form-row>

            <div
              v-if="
                form.products.length > 0 && form.productPricesInclTax.length > 0
              "
            >
              <hr />
              <b-form-row>
                <b-form-group class="col-6"> Nombre </b-form-group>
                <b-form-group class="col-1"> Unidades </b-form-group>
                <!--<b-form-group class="col-1"> Precio </b-form-group>-->
                <b-form-group class="col-1"> Subtotal </b-form-group>
                <!--<b-form-group class="col-1"> Suplemento </b-form-group>-->
                <b-form-group
                  v-if="$v.form.discountType.$model !== 'Total'"
                  class="col-2"
                >
                  Descuento
                </b-form-group>
              </b-form-row>

              <b-form-row
                :key="i"
                v-for="(product, i) in $v.form.products.$each.$iter"
              >
                <b-form-row class="col-12">
                  <b-form-group class="col-6">
                    <b-form-input
                      :disabled="true"
                      :value="product.reference.$model"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-1">
                    <b-form-input
                      type="text"
                      :value="
                        product.quantity.$model.toString().replace('.', ',')
                      "
                      @change="setDecimalProduct(i, 'quantity', $event)"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-1">
                    <b-form-input
                      type="number"
                      :step="0.01"
                      :disabled="true"
                      :aria-describedby="'input-products-subtotal-' + i"
                      :value="
                        form.productPricesExclTax[i]
                          ? form.productPricesExclTax[i].toFixed(2)
                          : form.productPricesExclTax[i]
                      "
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    v-if="$v.form.discountType.$model !== 'Total'"
                    class="col-1"
                  >
                    <b-input-group>
                      <b-form-input
                        id="productDiscount"
                        :value="form.productDiscounts[i]"
                        @change="changeProductDiscount(i, $event)"
                        :aria-describedby="
                          'input-productDiscounts-subtotal-' + i
                        "
                      ></b-form-input>
                      <template #append>
                        <b-input-group-text>%</b-input-group-text>
                      </template>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group
                    v-if="$v.form.discountType.$model !== 'Total'"
                    class="col-1"
                  >
                    <b-input-group>
                      <b-form-input
                        :disabled="true"
                        :value="form.productDiscountsAbsolute[i]"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group>
                    <b-button @click="deleteArticle(i)" variant="outline-danger"
                      ><b-icon icon="trash"></b-icon
                    ></b-button>
                    <b-button
                      class="ml-1"
                      @click="editArticle(i)"
                      variant="outline-primary"
                      ><b-icon icon="pencil"></b-icon
                    ></b-button>
                  </b-form-group>
                </b-form-row>

                <b-form-row class="col-12">
                  <ul v-if="product.type.$model !== 'free'" class="col-12">
                    <li
                      :key="j"
                      v-for="(attribute, j) in product.attributes.$each.$iter"
                    >
                      {{ attribute.label.$model }} :
                      {{ attribute.selector_inputs.$model.name }}
                    </li>
                    <li v-if="product.comments.$model" class="comments">
                      Comentarios:
                      <span style="white-space: pre">{{
                        product.comments.$model
                      }}</span>
                    </li>
                  </ul>
                  <ul v-else class="col-12">
                    <li>
                      {{ product.description.$model }}
                    </li>
                    <li v-if="product.comments.$model" class="comments">
                      Comentarios:
                      <span style="white-space: pre">{{
                        product.comments.$model
                      }}</span>
                    </li>
                  </ul>
                </b-form-row>
              </b-form-row>
              <hr />

              <b-form-row>
                <b-form-group class="col-1"> </b-form-group>
                <b-form-group class="col-6"> </b-form-group>
                <b-form-group class="col-1"> </b-form-group>
                <b-col :cols="3">
                  <b-row>
                    <b-col :cols="5">SUBTOTAL</b-col>
                    <b-col :cols="7"
                      >{{ form.totalPriceProductsExclTax.toFixed(2) }} €</b-col
                    >
                  </b-row>

                  <b-row align-v="center">
                    <b-col :cols="5">DESCUENTO</b-col>
                    <b-col :cols="3">-{{ form.discount.toFixed(2) }} €</b-col>
                    <b-col
                      :cols="4"
                      v-if="$v.form.discountType.$model === 'Total'"
                    >
                      <b-input-group size="sm">
                        <b-form-input
                          id="discountPct"
                          :value="$v.form.discountPct.$model.replace('.', ',')"
                          @change="
                            setDecimal('discountPct', $event);
                            changedDiscount();
                          "
                          :state="validateState('discountPct')"
                          aria-describedby="input-discountPct-feedback"
                        ></b-form-input>
                        <template #append>
                          <b-input-group-text>%</b-input-group-text>
                        </template>
                      </b-input-group></b-col
                    >
                  </b-row>

                  <b-row
                    class="mt-1 mb-1"
                    v-if="form.shippingMethod === 6"
                    align-v="center"
                  >
                    <b-col :cols="5">ENVÍO</b-col>
                    <b-col :cols="3"
                      >{{ parseFloat(form.shippingPrice).toFixed(2) }} €</b-col
                    >
                    <b-col :cols="4">
                      <b-input-group size="sm">
                        <b-form-input
                          id="shippingPrice"
                          :value="form.shippingPrice.replace('.', ',')"
                          @change="freeShippingChanged"
                          :state="validateState('shippingPrice')"
                          aria-describedby="input-shippingPrice-feedback"
                        ></b-form-input>

                        <template #append>
                          <b-input-group-text>€</b-input-group-text>
                        </template>
                      </b-input-group></b-col
                    >
                  </b-row>
                  <b-row v-else>
                    <b-col :cols="5">ENVÍO</b-col>
                    <b-col :cols="7">{{ form.shippingPrice }} €</b-col>
                  </b-row>
                  <b-row align-v="center">
                    <b-col :cols="5">{{ taxName }}</b-col>
                    <b-col :cols="7"
                      >{{ parseFloat(form.taxPrice).toFixed(2) }} €</b-col
                    >
                  </b-row>

                  <b-row>
                    <b-col :cols="5"><strong>TOTAL</strong></b-col>
                    <b-col :cols="7"
                      ><strong>{{ totalPrice.toFixed(2) }} €</strong></b-col
                    >
                  </b-row>
                </b-col>
              </b-form-row>
            </div>

            <b-form-row class="mt-2">
              <b-col :cols="12">
                <b-button type="submit" variant="primary">
                  {{
                    id === 'new' ? 'Guardar nuevo pedido' : 'Guardar pedido'
                  }}</b-button
                >
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  numeric,
  minValue,
  decimal,
  requiredIf,
} from 'vuelidate/lib/validators';
import ProductModal from '@/admin/components/quotes/ProductModal.vue';
import PredefinedProductModal from '@/admin/components/quotes/PredefinedProductModal.vue';

import OpenOrdersModal from '@/admin/components/orders/OpenOrdersModal.vue';

import FreeTextProductModal from '@/admin/components/quotes/FreeTextProductModal.vue';

import AdminCustomersEditScreen from '@/admin/screens/customers/AdminCustomersEditScreen.vue';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import * as Sentry from '@sentry/browser';
import Multiselect from 'vue-multiselect';

import moment from 'moment';
import 'moment/locale/es';

export default {
  name: 'AdminWorkshopOrdersEditScreen',
  props: ['id'],

  components: {
    Multiselect,
    ProductModal,
    PredefinedProductModal,
    FreeTextProductModal,
    AdminCustomersEditScreen,
    OpenOrdersModal,
  },
  mixins: [validationMixin],
  validations() {
    let rules = {
      created_by: {},
      customer: {},
      shippingMethod: {
        required: requiredIf(function (form) {
          return !this.isStockWorkshopOrder;
        }),
      },

      shippingAddress: {},
      mbe_tracking_code: {},
      extra_concept: {},
      one_liner_grouping_concept: {},

      billingAddress: {},

      productPricesInclTax: {
        required,
      },
      productPricesExclTax: {
        required,
      },

      productDiscounts: {},
      productDiscountsAbsolute: {},
      discountType: {
        required,
      },
      saleType: {
        required,
      },
      incotermType: {
        required,
      },
      discount: {
        required,
      },
      discountPct: {
        required,
      },

      totalPriceProductsInclTax: {
        required,
      },
      totalPriceProductsExclTax: {
        required,
      },
      shippingPrice: {
        required,
      },
      taxPrice: {
        required,
      },

      products: {
        $each: {
          reference: {
            required,
          },
          attributes: {
            $each: {
              selector_inputs: {
                required,
              },
              extra_info: {},
              label: {
                required,
              },
              reference: {
                // May be empty for predefined products
              },
            },
          },
          description: {},
          comments: {},
          quantity: {
            required,
          },
          type: {
            required,
          },
        },
      },
    };

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      customer: null,
      created_by: null,
      billingAddress: null,
      shippingMethod: null,
      shippingAddress: null,
      mbe_tracking_code: null,
      product: null,
      products: [],
      productPricesInclTax: [],
      productPricesExclTax: [],
      productDiscounts: [],
      productDiscountsAbsolute: [],
      discountType: 'Total',
      saleType: 'national',
      incotermType: null,

      discount: 0.0,
      discountTax: 0.0,
      discountPct: '0.0',
      totalPriceProductsInclTax: 0.0,
      totalPriceProductsExclTax: 0.0,
      shippingPrice: '0.0',
      shippingPriceInclTax: '0.0',

      taxPrice: 0.0,
      productHashes: [],
      extra_concept: '',
      one_liner_grouping_concept: '',
      // password: '',
      // password_confirmation: '',

      error: {
        show: false,
        text: '',
      },
    };

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,
      location: 1,
      quote_id: null,
      is_web_sale: false,
      billing_address_full: null,

      employeeProfileSelect: {
        loadedOptions: [],
      },

      customersMultiselect: {
        loadedOptions: [],
        isLoading: false,
      },
      employeeProfileMultiSelect: {
        loadedOptions: [],
        isLoading: false,
      },

      productsMultiselect: {
        loadedOptions: [],
        isLoading: false,
      },

      billingAddressSelect: {
        loadedOptions: [],
        selectedAddress: null,
      },

      shippingMethodSelect: {
        loadedOptions: [],
      },

      shippingAddressSelect: {
        loadedOptions: [],
      },

      discountTypeSelect: {
        options: [
          { text: 'Global', value: 'Total' },
          { text: 'Por producto', value: 'Per-product' },
        ],
      },

      saleTypeSelect: {
        options: [
          { text: 'Nacional', value: 'national' },
          { text: 'Intracomunitaria', value: 'intra-community' },
          { text: 'Exportación', value: 'export' },
          { text: 'Canarias', value: 'canary' },
          { text: 'Ceuta/Melilla', value: 'ceuta-melilla' },
        ],
      },
      incotermTypeSelect: {
        disabled: false,
        options: [
          { text: 'DDP', value: 'DDP' },
          { text: 'DAP', value: 'DAP' },
          { text: 'EXW', value: 'EXW' },
        ],
      },
      selectedProductID: null,
      selectedProductData: null,
      showModal: false,
      showFreeArticleModal: false,

      orderStatusHistories: [],
      selectedStatus: null,
    };
  },
  computed: {
    taxName() {
      // if (this.form.saleType == 'canary') {
      //   return 'IGIC';
      // } else if (this.form.saleType == 'ceuta-melilla') {
      //   return 'IPSI';
      // }
      return 'IVA';
    },
    orderStatusHistoriesFmt() {
      let arr = [];

      // Recogida en tienda (BAR, MAD)

      arr.push({ status: 'Received', date: null });
      arr.push({ status: 'Workshop', date: null });
      arr.push({ status: 'Finished', date: null });
      if (
        this.form.shippingMethod &&
        ![1, 2].includes(this.form.shippingMethod)
      ) {
        arr.push({ status: 'Sent', date: null });
      }
      arr.push({ status: 'Delivered', date: null });

      this.orderStatusHistories.map((x) => {
        let elem = arr.find((y) => y.status === x.status);
        if (elem) {
          elem['date'] = x.created_at;
        }
      });
      console.log('XXXXXXXXXXXX', arr);
      return arr;
    },
    isStockWorkshopOrder() {
      return (this.id === 'new' || this.quote_id === null) && !this.is_web_sale;
    },

    totalPrice() {
      return (
        parseFloat(this.form.totalPriceProductsInclTax) -
        parseFloat(this.form.discountTax) +
        parseFloat(this.form.shippingPriceInclTax)
      );
    },
  },
  created() {
    this.productsMultiselect.isLoading = true;
    this.customersMultiselect.isLoading = true;

    let promises = [];

    promises.push(actions.getCustomersUnpaginated());
    promises.push(actions.getProductsUnpaginated());
    promises.push(actions.getPredefinedProductsUnpaginated());
    promises.push(actions.getShippingMethodsUnpaginated());
    promises.push(actions.getEmployees());

    Promise.all(promises).then((x) => {
      this.shippingMethodSelect.loadedOptions = x[3].data.results.map((x) => {
        return {
          text: x.name + (x.id === 6 ? ' (libre)' : ' (' + x.cost + ' €)'),
          value: x.id,
          cost: x.cost,
        };
      });

      this.customersMultiselect.loadedOptions = x[0].data.results.map((x) => {
        return {
          text:
            x.full_name +
            (x.user && x.user.email ? ' (' + x.user.email + ')' : ''),
          value: x.id,
          default_discount: x.default_discount,
          email: x.user && x.user.email ? x.user.email : '',
        };
      });
      this.customersMultiselect.isLoading = false;

      this.productsMultiselect.loadedOptions = x[1].data.results.map((x) => {
        return {
          text: x.reference,
          value: x.id,
        };
      });

      this.productsMultiselect.loadedOptions = [
        ...this.productsMultiselect.loadedOptions,
        ...x[2].data.results.map((x) => {
          return {
            text: x.reference,
            value: 'PRE_' + x.id,
          };
        }),
      ];

      this.productsMultiselect.isLoading = false;

      // actions.getOrderStatusHistoriesByOrder(this.id).then((response6) => {
      //   this.orderStatusHistories = response6.data.results;
      // });

      // Employees
      this.employeeProfileMultiSelect.loadedOptions = x[4].data.results.map(
        (x) => {
          return {
            text: x.first_name + ' ' + x.last_name,
            value: x.id,
            works_here_today: x.workschedule_set.some(
              (xxx) =>
                xxx.day_of_week === moment().locale('en').format('dddd') &&
                xxx.location === this.location
            ),
          };
        }
      );

      const someEmployeeWorkingToday = this.employeeProfileMultiSelect.loadedOptions.filter(
        (xxx) => xxx.works_here_today === true
      );

      // console.log(someEmployeeWorkingToday);

      if (someEmployeeWorkingToday) {
        this.form.created_by = someEmployeeWorkingToday;
      }

      if (this.id !== 'new') {
        actions
          .getWorkshopOrderStatusHistoriesByWorkshopOrder(this.id)
          .then((response6) => {
            this.orderStatusHistories = response6.data.results;
          });

        actions.getWorkshopOrder(this.id).then((response2) => {
          const data = response2.data;

          this.form.mbe_tracking_code = data.mbe_tracking_code;
          this.form.billingAddress = data.billing_address;

          this.form.created_by = this.employeeProfileMultiSelect.loadedOptions.filter(
            (x) => data.created_by.includes(x.value)
          );

          this.form.shippingAddress = data.shipping_address;
          this.form.shippingMethod = data.shipping_method;

          this.form.products = data.products;

          this.form.shippingPrice = data.shipping_price;
          this.form.shippingPriceInclTax = data.shipping_price_incl_tax;

          this.form.saleType = data.sale_type;
          this.form.incotermType = data.incoterm_type;

          this.form.productPricesInclTax = data.product_prices_incl_tax;
          this.form.productPricesExclTax = data.product_prices_excl_tax;
          this.form.productDiscounts = data.product_discounts;
          this.form.productDiscountsAbsolute = data.product_discounts_absolute;

          this.form.productHashes = data.product_hashes;

          this.quote_id = data.quote;

          this.is_web_sale = data.is_web_sale;
          this.billing_address_full = data.billing_address_full;

          this.form.taxPrice = parseFloat(data.tax_price);

          this.form.discountPct = data.discount_pct;
          this.form.discount = parseFloat(data.discount);
          this.form.discountTax = parseFloat(data.discount_tax);
          this.form.discountType = data.discount_type;

          // this.form.location = data.location;

          this.form.totalPriceProductsInclTax = parseFloat(
            data.totalprice_products_incl_tax
          );

          this.form.totalPriceProductsExclTax = parseFloat(
            data.totalprice_products_excl_tax
          );

          this.selectedStatus = data.status;

          this.form.extra_concept = data.extra_concept;

          this.form.one_liner_grouping_concept =
            data.one_liner_grouping_concept;

          this.updateAvailableIncotermTypes();

          if (!this.isStockWorkshopOrder) {
            actions.getCustomer(data.customer).then((response3) => {
              const data = response3.data;

              this.form.customer = this.customersMultiselect.loadedOptions.find(
                (x) => x.value === data.id
              );
            });
            actions
              .getShippingAddressesByCustomer(data.customer)
              .then((response4) => {
                this.shippingAddressSelect.loadedOptions = response4.data.results.map(
                  (x) => {
                    return {
                      text: x.name,
                      value: x.id,
                    };
                  }
                );
              });

            actions
              .getBillingAddressesByCustomer(data.customer, 0)
              .then((response5) => {
                this.billingAddressSelect.loadedOptions = response5.data.results.map(
                  (x) => {
                    return {
                      text: x.name,
                      value: x.id,
                    };
                  }
                );

                if (this.form.billingAddress) {
                  this.billingAddressSelectChanged(
                    this.billingAddressSelect.loadedOptions.find(
                      (yy) => yy.value === this.form.billingAddress
                    ).value
                  );
                }
              });
          }
        });
      } else {
        this.selectedStatus = 'Received';
        // pepe
      }
    });
  },
  filters: {
    formatStatus: function (value) {
      return {
        Received: 'Recibido',
        Workshop: 'En taller',
        Finished: 'Terminado',
        Sent: 'Enviado',
        Delivered: 'Entregado',
      }[value];
    },
    formatBillingAddress: function (billingAddress) {
      const {
        full_name,
        street_address,
        street_address_2,
        urbanization,
        postal_code,
        city,
        country,
        country_name,
        company_id,
      } = billingAddress;

      let lines = [];
      if (full_name) lines.push(`${full_name}`);

      if (company_id) lines.push(`${company_id}`);

      if (street_address) lines.push(`${street_address}`);

      if (street_address_2) lines.push(`${street_address_2}`);

      if (urbanization) lines.push(`${urbanization}`);

      if (city) lines.push(`${city} (${postal_code})`);

      if (country_name) lines.push(`${country_name}`);

      return lines;
    },
  },
  methods: {
    updateAvailableIncotermTypes() {
      if (
        [1, 2].includes(this.$v.form.shippingMethod.$model) &&
        ['national', 'intra-community', 'canary', 'ceuta-melilla'].includes(
          this.$v.form.saleType.$model
        )
      ) {
        this.$v.form.incotermType.$model = 'EXW';
        this.incotermTypeSelect.disabled = true;
        this.incotermTypeSelect.options = [
          { text: 'DDP', value: 'DDP' },
          { text: 'DAP', value: 'DAP' },
          { text: 'EXW', value: 'EXW' },
        ];
        // this.incotermTypeSelect.find(x => ['DDP','DAP'].includes(x.value))
      } else if (
        ![1, 2].includes(this.$v.form.shippingMethod.$model) &&
        ['national', 'intra-community', 'canary', 'ceuta-melilla'].includes(
          this.$v.form.saleType.$model
        )
      ) {
        this.$v.form.incotermType.$model = 'DDP';
        this.incotermTypeSelect.disabled = true;
        this.incotermTypeSelect.options = [
          { text: 'DDP', value: 'DDP' },
          { text: 'DAP', value: 'DAP' },
          { text: 'EXW', value: 'EXW' },
        ];
        // this.incotermTypeSelect.find(x => ['DDP','DAP'].includes(x.value))
      } else if (
        [1, 2].includes(this.$v.form.shippingMethod.$model) &&
        ['export'].includes(this.$v.form.saleType.$model)
      ) {
        this.$v.form.incotermType.$model = 'EXW';
        this.incotermTypeSelect.disabled = true;
        this.incotermTypeSelect.options = [
          { text: 'DDP', value: 'DDP' },
          { text: 'DAP', value: 'DAP' },
          { text: 'EXW', value: 'EXW' },
        ];
        // this.incotermTypeSelect.find(x => ['DDP','DAP'].includes(x.value))
      } else if (
        ![1, 2].includes(this.$v.form.shippingMethod.$model) &&
        ['export'].includes(this.$v.form.saleType.$model)
      ) {
        this.$v.form.incotermType.$model = 'DDP';
        this.incotermTypeSelect.disabled = false;
        this.incotermTypeSelect.options = [
          { text: 'DDP', value: 'DDP' },
          { text: 'DAP', value: 'DAP' },
        ];
      }
    },
    shippingMethodChanged(val) {
      this.quotePrice(true);
      this.updateAvailableIncotermTypes();
    },
    freeShippingChanged(val) {
      this.setDecimal('shippingPrice', val);
      this.quotePrice(true);
    },
    disableStatusRadioBtn(i) {
      return (
        this.orderStatusHistoriesFmt[i].date !== null ||
        (i > 0 && this.orderStatusHistoriesFmt[i - 1].date === null)
      );
    },
    changedStatusLogic(sendUpdateEmail) {
      let data = {};
      data['status'] = this.selectedStatus;

      if (this.isStockWorkshopOrder) {
        // Change status, forget about emails, tracking codes etc.
        actions.patchWorkshopOrder(this.id, data).then((x) => {
          this.currentDeadlineDate = x.data.deadline_workshop;

          actions
            .getWorkshopOrderStatusHistoriesByWorkshopOrder(this.id)
            .then((response6) => {
              this.orderStatusHistories = response6.data.results;
            });
        });
        return;
      }

      data['send_notification_email'] = sendUpdateEmail;
      const isShipping = [3, 4, 5, 6, 7].includes(this.form.shippingMethod);

      // alert if shipping method is mailing (3,4) and shipping address is not set, do not change state
      if (
        this.selectedStatus === 'Finished' &&
        isShipping &&
        !this.form.shippingAddress
      ) {
        alert(
          'Acabas de marcar el pedido como terminado pero no hay una dirección de envío informada. Informa una dirección de envío y guarda los cambios, antes de hacer el cambio de estado.'
        );
        this.selectedStatus = 'Workshop';
        data['status'] = this.selectedStatus;
        return false;
      }

      // prompt to enter MBE tracking code when marked as Sent
      if (this.selectedStatus === 'Sent' && isShipping) {
        let currentTrackingCode =
          this.form.mbe_tracking_code !== null
            ? this.form.mbe_tracking_code
            : '';
        let trackingCode = prompt(
          'Introduce el código de seguimiento de MBE que se enviará al cliente.',
          currentTrackingCode
        );
        if (trackingCode === null) {
          // Pressed cancel, do not change state
          this.selectedStatus = 'Finished';
          data['status'] = this.selectedStatus;
          return false;
        } else if (currentTrackingCode !== trackingCode) {
          // Accepted, sending the code
          data['mbe_tracking_code'] = trackingCode;
        }
      }

      actions.patchWorkshopOrder(this.id, data).then((x) => {
        this.currentDeadlineDate = x.data.deadline_workshop;

        actions
          .getWorkshopOrderStatusHistoriesByWorkshopOrder(this.id)
          .then((response6) => {
            this.orderStatusHistories = response6.data.results;
          });
      });
    },
    changedStatus() {
      // automatic save

      const customerEmail = this.form.customer ? this.form.customer.email : '';

      const isShipping = [3, 4, 5, 6, 7].includes(this.form.shippingMethod);
      const isPickUp = !isShipping;

      if (
        !this.isStockWorkshopOrder &&
        customerEmail !== '' &&
        ('Workshop' === this.selectedStatus ||
          ('Finished' === this.selectedStatus && isPickUp) ||
          ('Sent' === this.selectedStatus && isShipping))
      ) {
        this.$bvModal
          .msgBoxConfirm(
            '¿Deseas enviar el email de actualización del pedido al cliente?',
            {
              title: 'Enviar email',
              size: 'sm',
              buttonSize: 'sm',
              okTitle: 'Sí, enviar el email',
              cancelTitle: 'No, no quiero avisarle',
              footerClass: 'p-2',
              hideHeaderClose: true,
              centered: true,
            }
          )
          .then((sendEmail) => {
            this.changedStatusLogic(sendEmail);
            // this.boxTwo = value;
          })
          .catch((err) => {
            // An error occurred
          });
      } else {
        this.changedStatusLogic(false); // does not matter, BE will not send
      }
    },

    changeProductDiscount(i, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.form.productDiscounts[i] = val;

      this.quotePrice();
    },

    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    setDecimalProduct(i, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.products.$each.$iter[i][name].$model = val;
      this.$v.form.products.$each.$iter[i][name].$touch();
      this.quotePrice();
    },

    changedDiscount() {
      this.quotePrice();
    },
    quotePrice() {
      let data = {};

      data['customer'] = this.form.customer ? this.form.customer.value : null;
      data['billing_address'] = this.form.billingAddress;

      data['products'] = this.form.products;

      data['discount_pct'] = this.form.discountPct;

      data['product_discounts'] = this.form.productDiscounts;

      data['sale_type'] = this.form.saleType;

      data['shipping_method'] = this.form.shippingMethod;

      if (this.$v.form.shippingMethod.$model === 6) {
        data['shipping_price'] = this.form.shippingPrice;
      }

      actions.postOrderPrice(data).then((x) => {
        // if (onlyUpdateDiscount) {
        //   this.form.discount = x.data.discount;
        //   this.form.isDiscountOverTax = x.data.isDiscountOverTax;
        //   this.form.taxPrice = x.data.taxPrice;
        // } else
        this.form.productPricesInclTax = x.data.productPricesInclTax;
        this.form.productPricesExclTax = x.data.productPricesExclTax;
        this.form.productDiscountsAbsolute = x.data.productDiscountsAbsolute;

        this.form.productHashes = x.data.productHashes;

        this.form.discount = x.data.discount;
        this.form.discountTax = x.data.discountTax;

        this.form.totalPriceProductsInclTax = x.data.totalPriceProductsInclTax;

        this.form.totalPriceProductsExclTax = x.data.totalPriceProductsExclTax;

        this.form.taxPrice = x.data.taxPrice;
        this.form.shippingPrice = x.data.shippingPrice.toFixed(2);
        this.form.shippingPriceInclTax = x.data.shippingPriceInclTax.toFixed(2);
      });
    },
    cancelAddProduct() {
      this.showModal = false;
    },
    editProduct(productData, attributes, currentPrice, qty, comments, images) {
      const editedArticleIndex = this.articleCurrentIndex;

      this.form.products.splice(editedArticleIndex, 1, {
        reference: productData.reference,
        // attributes: attributes.map((x, i) => {
        //   return {
        //     name: x.label,
        //     txtValue: x.selector_inputs.name,
        //     value: x.selector_inputs.value,
        //   };
        // }),
        attributes: attributes.map(function (item) {
          delete item.selector_options;

          if (item.reference === 'BORDADO') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'TELA') {
            delete item.extra_info.fabricsInfo;
          }

          if (item.reference === 'INICIALES') {
            delete item.extra_info.color_options;
          }

          if ('initial_value' in item) {
            delete item.initial_value;
          }

          return item;
        }),
        quantity: qty,
        type: productData.type,
        price: currentPrice,
        id: productData.id,
        description: productData.type === 'free' ? productData.description : '',
        comments: comments,
        images: images,
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.quotePrice();

      this.showFreeArticleModal = false;

      this.showModal = false;
    },
    addProduct(productData, attributes, currentPrice, qty, comments, images) {
      this.showModal = false;
      this.showFreeArticleModal = false;

      if (this.form.discountType === 'Per-product') {
        this.form.productDiscounts.push('0');
        this.form.productDiscountsAbsolute.push('0');
      }

      this.form.products.push({
        reference: productData.reference,
        attributes: attributes.map(function (item) {
          delete item.selector_options;

          if (item.reference === 'BORDADO') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'TELA') {
            delete item.extra_info.fabricsInfo;
          }

          if (item.reference === 'INICIALES') {
            delete item.extra_info.color_options;
          }

          if ('initial_value' in item) {
            delete item.initial_value;
          }

          return item;
        }),
        quantity: qty,
        type: productData.type,
        price: currentPrice,
        id: productData.id,
        description: productData.type === 'free' ? productData.description : '',
        comments: comments,
        images: images,
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.quotePrice();
    },
    deleteArticle(articleIndex) {
      this.form.products.splice(articleIndex, 1);
      this.quotePrice();
    },
    editArticle(articleIndex) {
      this.selectedProductID = this.form.products[articleIndex].id.toString();

      if (this.form.products[articleIndex].type === 'predefined') {
        this.selectedProductID = 'PRE_' + this.selectedProductID;
      }

      this.selectedProductData = this.form.products[articleIndex];
      this.articleCurrentIndex = articleIndex;

      if (this.selectedProductID === '0') {
        this.showFreeArticleModal = true;
      } else {
        this.showModal = true;
      }
    },
    addFreeTextArticleToQuoteBtn() {
      this.selectedProductID = null;
      this.selectedProductData = null;

      this.showFreeArticleModal = true;
    },
    addArticleToQuoteBtn() {
      this.selectedProductID = this.form.product.value.toString();
      this.selectedProductData = null;

      this.showModal = true;
    },
    incotermTypeChanged(val) {
      // if(val=='national'){
      // }
      // else if(val=='intra-community'){
      // }
      // else if(val=='export'){
      // }
      // else if(val=='canary'){
      // }
      // else if(val=='ceuta-melilla'){
      // }
      // this.quotePrice();
    },
    saleTypeChanged(val) {
      // if(val=='national'){

      // }
      // else if(val=='intra-community'){

      // }
      // else if(val=='export'){

      // }
      // else if(val=='canary'){

      // }
      // else if(val=='ceuta-melilla'){

      // }

      this.quotePrice();
    },
    discountTypeChanged(val) {
      if (val === 'Per-product') {
        let arr = [];
        for (let index = 0; index < this.form.products.length; index++) {
          arr.push('0');
        }

        this.form.productDiscounts = arr;
        this.form.productDiscountsAbsolute = arr;

        this.form.discountPct = '0';
        this.form.discount = 0;
      } else {
        this.form.discountPct = '0';
        this.form.discount = 0;
      }
    },
    billingAddressSelectChanged(val) {
      actions.getBillingAddress(val).then((z) => {
        this.billingAddressSelect.selectedAddress = z.data;
      });
    },

    customersMultiselectChanged(selectedOption, id) {
      if (selectedOption === null) {
        this.form.discountPct = '0';
        this.form.discount = 0;

        this.form.billingAddress = null;
        this.billingAddressSelect.loadedOptions = [];

        return;
      }

      this.setDecimal(
        'discountPct',
        selectedOption.default_discount.replace('.', ',')
      );
      this.changedDiscount();

      actions
        .getBillingAddressesByCustomer(selectedOption.value, 0)
        .then((y) => {
          this.billingAddressSelect.loadedOptions = y.data.results.map((x) => {
            return {
              text: x.name,
              value: x.id,
            };
          });
        });

      actions
        .getShippingAddressesByCustomer(selectedOption.value, 0)
        .then((y) => {
          this.shippingAddressSelect.loadedOptions = y.data.results.map((x) => {
            return {
              text: x.name,
              value: x.id,
            };
          });
        });
    },

    asyncFindProducts(query) {
      this.productsMultiselect.isLoading = true;

      let promises = [];
      promises.push(actions.getProductsGlobalSearch(query));
      promises.push(actions.getPredefinedProductsGlobalSearch(query));

      Promise.all(promises).then((response) => {
        let arr = [];

        arr = [
          ...arr,
          ...response[0].data.results.map((x) => {
            return {
              text: x.reference,
              value: x.id,
            };
            // eslint-disable-next-line prettier/prettier
          }),
        ];

        arr = [
          ...arr,
          ...response[1].data.results.map((x) => {
            return {
              text: x.reference,
              value: 'PRE_' + x.id,
            };
            // eslint-disable-next-line prettier/prettier
          }),
        ];

        this.productsMultiselect.loadedOptions = arr;

        this.productsMultiselect.isLoading = false;
      });
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateProduct(index, field) {
      const { $dirty, $error } = this.$v.form.products.$each[index][field];
      return $dirty ? !$error : null;
    },

    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = {};

      data['customer'] = this.form.customer ? this.form.customer.value : null;

      data['billing_address'] = this.form.billingAddress;
      data['shipping_address'] = this.form.shippingAddress;

      data['products'] = this.form.products;
      data['created_by'] = this.form.created_by.map((x) => x.value);
      data['shipping_method'] = this.form.shippingMethod;

      data['product_prices_incl_tax'] = this.form.productPricesInclTax;
      data['product_discounts'] = this.form.productDiscounts;
      data['product_discounts_absolute'] = this.form.productDiscountsAbsolute;
      data['discount_type'] = this.form.discountType;

      data['product_prices_excl_tax'] = this.form.productPricesExclTax;

      data['discount_pct'] = this.form.discountPct;
      data['discount'] = this.form.discount.toFixed(4);
      data['discount_tax'] = this.form.discountTax.toFixed(4);

      data['tax_price'] = this.form.taxPrice.toFixed(4);

      data[
        'totalprice_products_incl_tax'
      ] = this.form.totalPriceProductsInclTax.toFixed(4);
      data[
        'totalprice_products_excl_tax'
      ] = this.form.totalPriceProductsExclTax.toFixed(4);

      data['extra_concept'] = this.form.extra_concept;

      data['one_liner_grouping_concept'] = this.form.one_liner_grouping_concept;

      data['product_hashes'] = this.form.productHashes;

      data['total_price'] = this.totalPrice.toFixed(2);
      data['shipping_price_incl_tax'] = this.form.shippingPriceInclTax;
      data['shipping_price'] = this.form.shippingPrice;
      data['sale_type'] = this.form.saleType;

      // data['location'] = this.form.location;

      data['amt_paid_credit'] = this.form.amtPaidCredit;
      data['amt_paid_transfer'] = this.form.amtPaidTransfer;
      data['amt_paid_cash'] = this.form.amtPaidCash;

      data['incoterm_type'] = this.form.incotermType;

      Sentry.setExtra('data', JSON.stringify(data));

      if (this.id !== 'new') {
        actions.patchWorkshopOrder(this.id, data).then((x) => {
          this.$router.push({
            name: this.isStockWorkshopOrder
              ? 'AdminWorkshopStockOrdersScreen'
              : 'AdminWorkshopOrdersScreen',
          });
        });
      } else {
        actions.postWorkshopOrder(data).then((x) => {
          this.$router.push({
            name: this.isStockWorkshopOrder
              ? 'AdminWorkshopStockOrdersScreen'
              : 'AdminWorkshopOrdersScreen',
          });
        });
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.comments {
  margin-top: 0.2rem;
  font-style: italic;
}
</style>
